/**
 * SessionsActivityLog — per-day activity log section used in ActiveSessionsPage.
 * Uses the same data structures and style tokens as the original component.
 */
import React from 'react';
import { Calendar, RefreshCw } from 'lucide-react';
import { ActionBadge, thStyle, tdStyle } from '../ActiveSessionsBlocks';

const fmtShort = (s) => s ? new Date(s).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';

export function SessionsActivityLog({ activity, activityDate, activityLoading, onDateChange, onRefresh }) {
  return (
    <div className="card" data-testid="activity-log-card">
      {/* Card header with date picker */}
      <div className="card-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span className="card-title">
          <Calendar size={14} style={{ display: 'inline', marginRight: 6 }} />
          Activity Log · {activityDate}
          {activity.totals?.total > 0 && (
            <span style={{ marginLeft: 10, fontSize: 12, color: 'var(--text-muted)' }}>
              ({activity.totals.login || 0} login · {activity.totals.logout || 0} logout · {activity.totals.forced || 0} forced)
            </span>
          )}
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input
            type="date"
            value={activityDate}
            max={new Date().toISOString().slice(0, 10)}
            onChange={(e) => onDateChange(e.target.value)}
            data-testid="activity-date-picker"
            style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, border: '1px solid var(--border)' }}
          />
          <button className="erp-btn" onClick={onRefresh} data-testid="activity-refresh" style={{ fontSize: 12 }}>
            <RefreshCw size={11} className={activityLoading ? 'spinning' : ''} />
          </button>
        </div>
      </div>

      {/* Card body */}
      <div className="card-body" style={{ padding: 0, maxHeight: 320, overflowY: 'auto' }}>
        {!activity.events?.length ? (
          <div style={{ padding: 20, textAlign: 'center', fontSize: 12, color: 'var(--text-muted)' }}>
            No login/logout events recorded for this date.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border, #1e293b)', background: 'var(--surface-2, #0f172a)' }}>
                <th style={thStyle}>Time</th>
                <th style={thStyle}>Action</th>
                <th style={thStyle}>User</th>
                <th style={thStyle}>Details</th>
              </tr>
            </thead>
            <tbody>
              {activity.events.map((e, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--border, #1e293b)' }} data-testid={`activity-row-${i}`}>
                  <td style={tdStyle}>{fmtShort(e.timestamp)}</td>
                  <td style={tdStyle}><ActionBadge action={e.action} /></td>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{e.user}</td>
                  <td style={{ ...tdStyle, color: 'var(--text-muted, #94a3b8)', fontSize: 12 }}>{e.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
